import { render, staticRenderFns } from "./WasteWeightCollected.vue?vue&type=template&id=5771d933&scoped=true&"
import script from "./WasteWeightCollected.vue?vue&type=script&lang=js&"
export * from "./WasteWeightCollected.vue?vue&type=script&lang=js&"
import style0 from "./WasteWeightCollected.vue?vue&type=style&index=0&id=5771d933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5771d933",
  null
  
)

export default component.exports